/**
 * Sanitizes a ZIP code input by removing non-digit characters and limiting to 5 digits.
 * @param zipValue - The raw ZIP code input
 * @returns Sanitized ZIP string containing only digits, max 5 characters
 */
export const normalizeZip = (zipValue: string | null | undefined): string =>
  String(zipValue || '')
    .replace(/[^\d]/g, '')
    .slice(0, 5);

/**
 * Validates whether a ZIP code is a complete 5-digit ZIP.
 * @param zipValue - The ZIP code to validate
 * @returns True if the ZIP is exactly 5 digits
 */
export const isValidZip = (zipValue: string): boolean =>
  normalizeZip(zipValue).length === 5;
